module.exports = __webpack_public_path__ + "img/black.0bc2be9e.webp";